export const zh = {
  zh: {
    logout: `logout`,
    game: `game`,
    history: `history`,
    back: `back`,
    maintenance: `maintenance`,
    maintenance_desc: `We will be back shortly`,
    play_now: `play now`,

    logout_title: `<i class="tx--logout -zh"></i>`,
    alert_title: `<i class="tx--alert -zh"></i>`,
    chat_title: `<i class="tx--chat -zh"></i>`,

    sort: `sort`,

    //= language
    language: [
      { id: 0, name: 'en' },
      { id: 2, name: 'jp' },
      { id: 1, name: 'kr' },
      { id: 3, name: 'zh' }
    ],

    //= navigation
    home: `home`,
    popular: `popular`,
    live_games: `live games`,
    table_games: `table games`,
    slot_games: `slot games`,
    other_games: `other games`,

    //= alerts
    error: `错误`,
    prompt: `are you sure?`,
    info: `详情`,
    success: `成功`,

    ok: `ok`,
    cancel: `取消`,
    failed: `失败`,

    //= titles
    slot_payline: `slot payline`,
    game_provider: `game provider`,
    faq: `faq`
  }
}
